export default "__VITE_ASSET__e321c16f__"